import {Component, Emit, Prop, Watch, Vue} from 'vue-property-decorator';
import { WorkItem } from '@/types';
import store from '@/assets/common/store/store';

@Component({
    components: {
    }
})
export default class WorkItemDetail extends Vue {

    private baseUrl = '/work_items';
    private workItemName = "";
    private workItemMemo = "";
    private unEditedWorkItem!: WorkItem;
    private hasNotName = false;
    private isNameCharLimit = false;

    @Prop()
    private selectedWorkItem!: WorkItem;

    @Watch("selectedWorkItem",{ immediate: true })
    private changeWorkItem(newVal: WorkItem) {
        this.unEditedWorkItem = newVal;
        this.workItemName = newVal.name;
        this.workItemMemo = newVal.memo;
        this.hasNotName = false;
        this.isNameCharLimit = false;
    }

    private get headerTitle() {
        if(this.selectedWorkItem.id === 'create') {
            return '新規作業項目';
        } else {
            return '作業項目';
        }

    }

    private switchDisplay(isHidden: boolean) {
        if (!window.confirm(`${this.workItemName}を${ !isHidden? '表示状態に戻します' : '非表示にします' }。よろしいですか？`)){
            return
        }

        this.selectedWorkItem.is_hidden = isHidden;

        this.$apiClient.doRequest('put', `${this.baseUrl}/${this.selectedWorkItem.id}`, this.selectedWorkItem).then((res) => {
            if(isHidden) {
                this.$router.push('/master/work_items', () => {return});
            } else {
                this.$router.push(`/master/work_items/${this.selectedWorkItem.id}`, () => {return});
            }
            this.$toasted.success('変更を保存しました。')
            this.switchedDisplay(res.id);
        })
        .catch(() => {
            this.$toasted.error('変更に失敗しました。')
        })
    }

    private cancelEdit() {
        if (this.$store.getters.isInputChanged) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                return false;
            }
        }
        this.$store.dispatch('doUpdateIsInputChanged', false);
        this.workItemName = this.unEditedWorkItem.name;
        this.workItemMemo = this.unEditedWorkItem.memo;
        this.hasNotName = false;
        this.isNameCharLimit = false;
    }

    private validate() {
        const errmsg: string[] = []

        // 名前
        if(!this.workItemName){
            errmsg.push('作業名を入力してください')
        }
        // 名前の長さ
        if(this.workItemName.length > 100){
            errmsg.push(`作業名は100文字以内で入力してください（現在は${this.workItemName.length}文字）`)
        }
        // メモ
        if(this.workItemMemo && this.workItemMemo.length > 21844) {
            errmsg.push(`メモは21844文字以内で入力してください（現在は${this.workItemMemo.length}文字）`)
        }

        if(errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }

        return true
    }

    private submit() {
        if(!this.validate()) {
            return;
        }
        const newWorkItem: WorkItem = {
            id: this.selectedWorkItem.id,
            name: this.workItemName,
            memo: this.workItemMemo,
            is_hidden: this.selectedWorkItem.is_hidden
        }
        if( newWorkItem.id === 'create'){
            this.$apiClient.doRequest('post', this.baseUrl, newWorkItem).then((res) => {
                this.submitEnd(false);
                this.$toasted.success('作成が完了しました。')
            })
            .catch(() => {
                this.$toasted.error('作成に失敗しました。')
                this.submitEnd(false);
            })
        } else {
            const result = window.confirm("内容を上書きして保存します。よろしいですか。")
            if(!result) {
                return false;
            }
            this.$apiClient.doRequest('put', `${this.baseUrl}/${this.selectedWorkItem.id}`, newWorkItem).then((res) => {
                this.submitEnd(false);
                this.$toasted.success('変更を保存しました。')
            })
            .catch(() => {
                this.$toasted.error('変更に失敗しました。')
                this.submitEnd(false);
            })
        }
        this.hasNotName = false;
        this.isNameCharLimit = false;
        this.$store.dispatch('doUpdateIsInputChanged', false);

    }

    @Emit('switchedDisplay')
    private switchedDisplay(id: string) {
        return id;
    }

    @Emit('submitEnd')
    private submitEnd(showAll: boolean) {
        return showAll;
    }

    @Emit('inputChanged')
    private inputChanged(){
        if(store.getters.isInputChanged==false){
        this.$store.dispatch('doUpdateIsInputChanged', true);
        }
    }
}